import { Box, MaxWidth, Stack, Text, Flex } from "@sqymagma/elements"
import React from "react"
import IconSystem from "../components/IconSystem"

const Footer = () => {
  return (
    <Box bg="ui07">
      <MaxWidth>
        <Stack
          mx="auto"
          flexDirection={["column", null, "row"]}
          alignItems="center"
          justifyContent={["space-between", null, "flex-start"]}
          hs={[0, null, null, "l"]}
          vs={["s", null, null, 0]}
          p="s"
        >
          <Text as="span" color="inverse01" textStyle="tiny" textAlign="center">
            <Text 
              as="a" 
              href="mailto:coronavirus@secuoyas.com"
              css="{
                &:hover {
                  opacity: .7;
                  transition: opacity ease .3s;
                }
              }">
              coronavirus@secuoyas.com
            </Text>{"  ·  "}
            Centro de información
          </Text>
          <Flex pb={["m", "m", 0, 0]} order={[-1, -1, 0, 0]} px="m">
            <IconSystem name="logoBlack" height="18px" fill="inverse01"/>
          </Flex>
          <Text as="span" color="inverse01" textStyle="tiny" textAlign="center">
            <Text 
              as="a" 
              href="https://secuoyas.com"
              css="{
                &:hover {
                  opacity: .7;
                  transition: opacity ease .3s;
                }
              }">
            Secuoyas.com
            </Text>{"  —  "}
            Fuentes de datos: mscbs.gob.es y Depts. de Salud de las CCAA
          </Text>
        </Stack>
      </MaxWidth>
    </Box>
  )
}
export default Footer

